var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import AgendaAbstract from "../../ui/AgendaAbstract/AgendaAbstract";
import AgendaTitle from "../../ui/AgendaTitle/AgendaTitle";
import { SanitizeHtml } from "../../ui/SanitizeHtml/SanitizeHtml";
export var AgendaAbstractModal = function (_a) {
    var agenda = _a.agenda;
    return (_jsxs(_Fragment, { children: [_jsx(AgendaTitle, __assign({ titleLevel: 5 }, { children: _jsx(SanitizeHtml, { stringToSanitize: agenda.title, tag: "div" }) })), _jsx(AgendaAbstract, { description: agenda.description })] }));
};
export var getAgendaAbstractModalProps = function () {
    return {};
};
